import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  imagesLabels: [],
  getAllImagesLabels: []
};

export const ImagesLabelsSlice = createSlice({
  name: "imagesLabels",
  initialState,
  reducers: {
    getImagesLabelsAction: (state, action) => {
      state.imagesLabels = action.payload;
    },
  },
});

export default ImagesLabelsSlice.reducer;

export const { getImagesLabelsAction } = ImagesLabelsSlice.actions;
